import React from "react";
import { useLocation } from "react-router-dom";

export default function VehicleDetails() {
  const { state } = useLocation();
  const v = state?.vehicle;

  if (!v) return <h2>No vehicle found</h2>;

  return (
    <div className="vehicle-details-page">
      <div className="row">
        <div className="col-md-6">
          <img src={v.image} className="main-img" alt="" />

          {/* thumbnails */}
          <div className="thumb-row">
            <img src={v.image} className="thumb" alt="" />
            <img src={v.image} className="thumb" alt="" />
            <img src={v.image} className="thumb" alt="" />
          </div>
        </div>

        <div className="col-md-6">
          <h2>{v.name}</h2>

          <table className="spec-table">
            <tbody>
              <tr><td>Body</td><td>{v.body}</td></tr>
              <tr><td>Seating Capacity</td><td>{v.seats}</td></tr>
              <tr><td>Doors</td><td>{v.doors || "-"}</td></tr>
              <tr><td>Engine</td><td>{v.engine || "-"}</td></tr>
              <tr><td>Transmission</td><td>{v.transmission || "-"}</td></tr>
              <tr><td>Fuel Type</td><td>{v.fuel || "-"}</td></tr>
              <tr><td>AC</td><td>{v.ac}</td></tr>
            </tbody>
          </table>

          <div className="details-section">
            <h4>Details</h4>
            <ul>
              <li>4 Hrs / 40 Kms</li>
              <li>8 Hrs / 80 Kms</li>
              <li>Pune Airport Pickup / Drop</li>
              <li>Mumbai Airport Pickup / Drop</li>
              <li>Outstation Use Available</li>
            </ul>
          </div>

          <button className="btn-red">Book Now</button>
        </div>
      </div>
    </div>
  );
}
